import React from 'react';
import { Target, Globe, Users, Sparkles } from 'lucide-react';
import { missionVision } from '../data/mockData';
import { useLanguage } from '../context/LanguageContext';

const iconMap = {
  1: Target,
  2: Globe,
  3: Users,
  4: Sparkles
};

const MissionVisionSection = () => {
  const { t } = useLanguage();

  return (
    <section className="py-16" style={{
      background: 'linear-gradient(180deg, #130a28 0%, #100820 100%)'
    }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-white mb-4">
            {t('missionTitle')}
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto">
            {t('missionDesc')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {missionVision.map((item) => {
            const Icon = iconMap[item.id] || Target;
            return (
              <div 
                key={item.id} 
                className="bg-[#1a1a2e]/50 rounded-xl p-6 text-center transition-all duration-300 hover:bg-[#2a2a3e]/50"
              >
                <div className="w-14 h-14 rounded-full bg-gradient-to-br from-pink-600/30 to-purple-600/30 flex items-center justify-center mx-auto mb-4">
                  <Icon className="w-7 h-7 text-pink-400" />
                </div>
                <h3 className="text-lg font-semibold text-white mb-2">{item.title}</h3>
                <p className="text-gray-400 text-sm">{item.description}</p>
              </div>
            );
          })}
        </div>

        {/* Vision Statement */}
        <div className="bg-[#1a1a2e]/50 rounded-2xl p-8 lg:p-12 border border-purple-500/10 text-center">
          <h3 className="text-2xl font-bold text-white mb-6">{t('ourVision')}</h3>
          <p className="text-xl text-gray-300 italic mb-8 max-w-3xl mx-auto">
            "{t('visionQuote')}"
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            {['Unity', 'Wisdom', 'Healing', 'Love'].map((value) => (
              <span 
                key={value} 
                className="bg-pink-600/10 text-pink-300 px-6 py-2 rounded-full text-sm font-medium border border-pink-500/20"
              >
                {value}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionVisionSection;
